import { fetcher } from '@commenda/utils';

export async function deleteComplianceCalendarForCorporation(
  corporationId: number,
  token: string
): Promise<boolean> {
  const res = await fetcher(
    `compliance/calendar/corporation/${corporationId}`,
    { method: 'DELETE' },
    token
  );

  if (!res.ok) {
    return false;
  }

  return true;
}
